export default __webpack_public_path__ + "static/jira-product-discovery_attribution_dark-2ec824158dff60938702426686a112728109fd9ca104355f877c855101e0cc33.svg";